import { ThemeProvider, createTheme } from "@mui/material";
import { ReactNode } from "react";

declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
    navbar: true;
  }
}
export default function Themed({ children }: { children: ReactNode }) {
  const theme = createTheme({
    palette: { primary: { main: "#082009", contrastText: "#fff4e8" }, secondary: { main: "#fff4e8", contrastText: "#082009" } },
    breakpoints: {
      values: {
        xs: 0,
        sm: 640,
        md: 900,
        lg: 1200,
        xl: 1536,
        navbar: 640, // defines when the navbar changes
      },
    },
  });
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
